import {IS_LOGGED_IN, CHANGE_LANGUAGE, CLEAR_STATE} from "../types";

const INITIAL_STATE = {
    logged: null,
    language: 'es',
    userName: '',
    isRA:false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case IS_LOGGED_IN:
            return {...state, ...action.payload.auth};
        case CHANGE_LANGUAGE:
            return {...state, ...action.payload.auth};
        case CLEAR_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};